export default "<p>communicationv2 works!</p>\n";